<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <h2>SGO - Situações de Demanda</h2>
    <h3>Admin</h3>
  </div>
  <div class="col-lg-2"></div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
          <div class="info-page">
            <h3>{{ actionLabel }}</h3>
          </div>

          <form [formGroup]="form" (ngSubmit)="salvar()" *ngIf="!isLoading">
            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Palavra-Chave</label>
                <input type="text" id="keyword" class="form-control" formControlName="keyword" required />
                <app-field-message [field]="fieldMessageRequired('keyword') || _erros?.keyword" [textErroServer]="_erros?.keyword" [erros]="fieldErros('keyword')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Descrição</label>
                <input type="text" id="description" class="form-control" formControlName="description" required />
                <app-field-message [field]="fieldMessageRequired('description') || _erros?.description" [textErroServer]="_erros?.description" [erros]="fieldErros('description')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Módulo</label>
                <ng-select id="sgo_module_id" class="ng-select-alternative" [items]="sgoModulo" bindLabel="name" bindValue="id" formControlName="sgo_module_id" placeholder="Selecione o Módulo">
                </ng-select>
                <app-field-message [field]="fieldMessageRequired('sgo_module_id') || _erros?.sgo_module_id" [textErroServer]="_erros?.sgo_module_id" [erros]="fieldErros('sgo_module_id')"></app-field-message>
              </div>
            </div>

            <div class="hr-line-dashed"></div>
            <div class="form-group row d-flex justify-content-end">
              <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
                <button class="btn btn-primary" type="submit">Salvar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>